<ul nz-menu id="menu" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
  @for (item of menu | sortBy: 'sortId'; track item) {
    @if (item?.acls | checkMenuAcl: item | async) {
      <li nz-menu-item nzMatchRouter [nzDisabled]="item.disabled" [routerLink]="item.url">
        @if (item.icon) {
          <i nz-icon [nzType]="item.icon"></i>
        }

        @if (item.namedIcon) {
          <i nz-icon>
            <i class="tripium-icon {{ item.namedIcon }}"></i>
          </i>
        }

        <span>{{ item.title }}</span>
      </li>
    }
  }
</ul>
